import { render, staticRenderFns } from "./StockBatchUpdateNew.vue?vue&type=template&id=07e650a8&scoped=true&"
import script from "./StockBatchUpdateNew.vue?vue&type=script&lang=js&"
export * from "./StockBatchUpdateNew.vue?vue&type=script&lang=js&"
import style0 from "./StockBatchUpdateNew.vue?vue&type=style&index=0&id=07e650a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e650a8",
  null
  
)

export default component.exports